import { Dialog, DialogTitle, DialogContent, Divider, Grid, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme, Theme } from '@mui/material/styles';

const officialCapacityExamples = [
  ['Acting in official capacity & armed', 'Cleared'],
  ['Not acting in official capacity & unarmed', 'Cleared'],
  ['Not acting in official capacity & armed', 'Not cleared']
]

const OfficialCapacityQuestionDialog = ({
  open = false,
  onClose,
}: {
  open: boolean;
  onClose: (boolean) => void;
}) => {
  const theme: Theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{ paper: { style: { borderRadius: 8 } } }}
    >
      <IconButton
          aria-label="close"
          onClick={() => onClose(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500]
          })}
        >
        <CloseIcon sx={{ fontSize: 32, color: theme.palette.grey[600] }} />
      </IconButton>
      <DialogTitle sx={{ fontSize: '24px' }}>If official capacity question is enabled</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid
            container
            size={12}
            sx={{
              justifyContent: 'space-between',
              mt: 1
            }}>
            <Grid size={8}>
              <Typography sx={{
                fontSize: '14px'
              }}>Given the following conditions:</Typography>
            </Grid>
            <Grid size={4}>
              <Typography sx={{
                fontSize: '14px'
              }}>Clearance outcome:</Typography>
            </Grid>
            <Grid size={12} sx={{
              mt: 2
            }}>
              <Divider />
            </Grid>
          </Grid>

          {
            officialCapacityExamples.map((example, i) => (
              <Grid
                container
                size={12}
                sx={{
                  justifyContent: 'space-between',
                  mt: 1
                }}>
                <Grid size={8}>
                  <Typography variant='body1' align='left' sx={{
                    fontSize: '16px'
                  }}>{example[0]}</Typography>
                </Grid>
                <Grid size={4}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: '16px'
                    }}>{example[1]}</Typography>
                </Grid>
                {
                  i + 1 < officialCapacityExamples.length
                    ? (
                        <Grid size={12} sx={{
                          mt: 1
                        }}>
                          <Divider />
                        </Grid>
                      )
                    : null
                }
              </Grid>
            ))
          }
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default OfficialCapacityQuestionDialog;